import { createGetOptionsApi } from "..";
import { Urls } from "../../helpers/api-urls";

export const getStateOptions = createGetOptionsApi(Urls.GetStateOptions, "stateOptions", 3);
